import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { TListResponsePayload } from 'src/dal/typing';
import { UseCustomQueryOptions } from 'src/shared/utils/queryHelpers';

import { generateQueryKeys } from '../utils';
import { getLegalsFetcher } from './legalService';
import { TLegal } from './typing';

const legalsQueryKeys = generateQueryKeys('legals');

const QueryLegalsGetOptions = (
  options?: UseCustomQueryOptions<TListResponsePayload<TLegal>>,
): UseQueryOptions<TListResponsePayload<TLegal>> => ({
  queryKey: [legalsQueryKeys.all],
  queryFn: async () =>
    getLegalsFetcher({
      options: {
        cache: 'force-cache',
        next: {
          revalidate: 10 * 60,
          tags: ['legals'],
        },
      },
    }),
  ...options,
});

export const useQueryLegalsGet = (
  options?: UseCustomQueryOptions<TListResponsePayload<TLegal>>,
): UseQueryResult<TListResponsePayload<TLegal>> => useQuery(QueryLegalsGetOptions(options));
